import { getTimeAsMinutesSeconds } from "../../helpers/helpers";

const TimelineRCP = ({ data, startTime, endTime }) => {
  const colorGreenPrimary = "#2AAC9C";
  const colorRedError = "#D63B59";

  const totalDuration = endTime - startTime;

  // Filter only RCP events
  const dataRCP = data.filter((item) => item.object === "RCP");

  // Convert flat events to interval pairs
  const intervalPairs = [];
  for (let i = 0; i < dataRCP.length - 1; i += 2) {
    const start = dataRCP[i].time;
    const stop = dataRCP[i + 1]?.time || endTime;

    // Only add if both are present
    if (start && stop) {
      intervalPairs.push({ start, stop });
    }
  }

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: "32px",
      }}
    >
      {intervalPairs.map((item, index) => {
        const intervalTime = item.stop - item.start;
        const intervalLongerThan2min = intervalTime > 120000; // 2 * 60 * 1000
        const leftPercent = ((item.start - startTime) / totalDuration) * 100;
        const widthPercent = ((item.stop - item.start) / totalDuration) * 100;

        return (
          <div key={index}>
            {/* Interval bar */}
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: `${leftPercent}%`,
                width: `${widthPercent}%`,
                height: "16px",
                backgroundColor: intervalLongerThan2min
                  ? colorRedError
                  : colorGreenPrimary,
                borderRadius: "3px",
                transform: "translateY(-50%)",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: "20px",
                  left: `50%`,
                  fontSize: "10px",
                  transform: "translateX(-50%)",
                }}
              >
                {getTimeAsMinutesSeconds(intervalTime)}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default TimelineRCP;
